import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component:()=>import('../views/web/index.vue'),
    meta:{title:'易拓国际'},
    children:[
      {path:'/',component:()=>import('../views/web/home.vue'),meta:{title:'易拓国际'}},
      {path:'/details',component:(()=>import('../views/web/details.vue')),meta:{title:'易拓国际'}},
      {path:'/listing',component:(()=>import('../views/web/listing.vue')),meta:{title:'易拓国际'}},
    ]

  },
  {
    path:'/login',
    component:()=>import('../views/background/login.vue')
  },
  {
    path: '/index', 
    component: ()=>import('../views/background/index.vue'),
    meta:{title:'宜联科技', requireAuth:true,},
    children:[
      {path:'/index',component:()=>import('../views/background/home.vue'),meta:{title:'首页', requireAuth:true}},
      {path:'/allModule',component:()=>import('../views/background/allModule.vue'),meta:{title:'文章管理', requireAuth:true}},
      {path:'/addvideo',component:()=>import('../views/background/addvideo.vue'),meta:{title:'文章管理', requireAuth:true}},
      {path:'/addarticle',component:()=>import('../views/background/addarticle.vue'),meta:{title:'文章管理', requireAuth:true}},
      {path:'/account',component:()=>import('../views/background/account.vue'),meta:{title:'账号管理', requireAuth:true}},
      {path:'/member',component:()=>import('../views/background/member.vue'),meta:{title:'首页', requireAuth:true}},
      {path:'/memberPrice',component:()=>import('../views/background/memberPrice.vue'),meta:{title:'首页', requireAuth:true}},
      {path:'/memberOrder',component:()=>import('../views/background/memberOrder.vue'),meta:{title:'首页', requireAuth:true}},


    ],
  },
  {path:'*',component:()=>import('../views/web/index.vue')},
]

const router = new VueRouter({
  routes,
  mode:'history'
})
router.beforeEach((to, from, next)=>{
  if(to.meta.title){
    document.title=to.meta.title;
  };
  if(to.meta.requireAuth){
    if(sessionStorage.getItem('user_token')){
      next()
    }else{
      next('/login');
    }
  }else{
    next()
  }
})  
export default router
